const expedition = require('@/apps/expedition/api/expedition');

let api = {};

Object.assign(api, expedition.default)

export default api;
